import React from "react";

const getClass = (className) => "owl-selctor " + (className || "");

const Selector = (prop) => {
    const [options, setOptions] = React.useState(prop.options);
    console.debug("Selector RD");
    const init = async () => {
        if (prop.getData) {
            let _options = await prop.getData();
            setOptions(_options);
            setTimeout(() => {
                document.getElementById(prop.id || prop.queryKey + "-selector").value = prop.value;
            }, 10);
        }
    };
    React.useMemo(init, []);
    const _class = React.useMemo(() => getClass(prop.className), []);

    return (
        <select id={prop.id || prop.queryKey + "-selector"} key={prop.queryKey} defaultValue={prop.value} className={_class} onChange={onChange}>
            {options?.map((item) => (
                <option value={item.id} key={item.id}>
                    {item.title}
                </option>
            ))}
        </select>
    );

    function onChange(e) {
        let currentTarget = e.currentTarget;
        let value = e.target.value;
        let founded = prop.options.find((o) => o.id == value);
        currentTarget.className = getClass(founded?.className);
        if (prop.storageKey) localStorage.setItem(prop.storageKey, value);

        if (prop.showInClearBar) {
            prop.titleValue = founded.title;
            prop.clear = () => {
                value = prop.options[0].id;
                currentTarget.className = getClass(prop.options[0]?.className);
                currentTarget.value = value;
                if (prop.storageKey) localStorage.setItem(prop.storageKey, value);
            };
        }
        prop.onChange(value);
    }
};
export default React.memo(Selector);
